import { createRouter, createMemoryHistory } from 'vue-router';

const routes = [
    {
        path: '/',
        redirect: '/home'
    }, {
        path: '/home',
        name: 'home',
        component: () => import('../views/homePage.vue')
    }, {
        path: '/lendingPartner',
        name: 'lendingPartner',
        component: () => import('../views/lendingPartner.vue')
    }, {
        path: '/about',
        name: 'aboutUS',
        component: () => import('../views/aboutUS.vue')
    }, {
        path: '/contact',
        name: 'contactUS',
        component: () => import('../views/contactUS.vue')
    }, {
        path: '/privatePolicy',
        name: 'privatePolicy',
        component: () => import('../views/privatePolicy.vue')
    }, {
        path: '/loanAgreement',
        name: 'loanAgreement',
        component: () => import('../views/loanAgreement.vue')
    }, {
        path: '/privatePolicy_PrimeBaht',
        name: 'privatePolicy_PrimeBaht',
        component: () => import('../views/privatePolicy_PrimeBaht.vue')
    }, {
        path: '/loanAgreement_PrimeBaht',
        name: 'loanAgreement_PrimeBaht',
        component: () => import('../views/loanAgreement_PrimeBaht.vue')
    }
]

const router = createRouter({
    history: createMemoryHistory(),
    routes
})

export default router;
